import { render, staticRenderFns } from "./ReviewsTagsList.vue?vue&type=template&id=34cabbbe&scoped=true&"
import script from "./ReviewsTagsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsTagsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ReviewsTagsList.vue?vue&type=style&index=0&id=34cabbbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cabbbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cabbbe')) {
      api.createRecord('34cabbbe', component.options)
    } else {
      api.reload('34cabbbe', component.options)
    }
    module.hot.accept("./ReviewsTagsList.vue?vue&type=template&id=34cabbbe&scoped=true&", function () {
      api.rerender('34cabbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsTags/components/ReviewsTagsList.vue"
export default component.exports